import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import styles from "./index.module.scss";
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { getMenuList } from '@/redux/base.redux';
import SearchProduct from '@/components/SearchProduct';
import { api } from '@/routes/api';
import axios from '@/util/axios';
import { Loading } from '@/components/Loading';
import NoProductIcon from '@/images/no-product-list.png';
import { menuList } from '../../config/menu';

@withRouter
@connect(
  state => state.base,
  { getMenuList }
)
class Index extends Component {
  state = {
    isShowInput: false,
    isShowNav: false,
    firstNavId: -1,
    secondNavId: -1,
    thirdNavId: -1,
    secondMenu: [],
    thirdMenu: [],
    list: [],
    count: 0,
    isLoading: false,
    showResult: false,
    ambulance: ''
  }
  componentDidMount() {
    this.props.getMenuList();

    // 第一种 路由变化时置顶
    this.props.history.listen(() => {
      //当路由切换时
      window.scrollTo(0, 0);
      this.setState({ isShowNav: false });
    });
    document.addEventListener("click", this.handleBodyClick);
  }
  componentWillUnmount = () => {
    document.removeEventListener("click", this.handleBodyClick);
  }
  // 第二种 props变化时置顶
  componentWillReceiveProps(nextProps) {
    //当路由切换时
    if (this.props.location !== nextProps.location) {
      window.scrollTo(0, 0);
      this.setState({ isShowNav: false });
    }
  }
  handleBodyClick = (e) => {
    const { isShowInput } = this.state;
    if (isShowInput) this.setState({ isShowInput: false, showResult: false });
  }
  handleNavClick = (e) => {
    const { isShowNav } = this.state;
    if (isShowNav) this.setState({ isShowNav: false });
  }
  renderMenu(menu) {
    const productId = this.props.location.pathname.split("/")[2] || -1;
    const { isShowInput } = this.state;
    return menu.map(menu => {
      return (
        <li
          key={menu.id}
          className={"das"}
        >
          <div className="source-code-pro">{menu.subcats ? menu.title : <Link className={parseInt(productId) === parseInt(menu.id) ? styles.active : ''} to={`/product/${menu.id}`}>{menu.title}</Link>}</div>
          {menu.subcats.length > 0 ? (
            !isShowInput ? <ul className={styles.subMenu_list}>{this.renderMenu(menu.subcats)}</ul> : null
          ) : null}
        </li>
      );
    });
  }

  //手机端导航
  renderFirstMenu(menu) {
    const { firstNavId } = this.state;
    return menu.map(item => {
      return (
        <li key={item.id} onClick={this.setSecondMenuClick.bind(this, item.id, item.children)} className={`${firstNavId === item.id ? styles.border_active : ''}`}>{item.title}</li>
      );
    })
  }
  setSecondMenuClick = (id, menu, e) => {
    this.setState({ firstNavId: id, secondMenu: menu, thirdMenu: [] });
  }
  renderSecondMenu() {
    const pageKey = "/" + this.props.location.pathname.split("/")[1] || '';
    const { secondMenu, secondNavId, thirdMenu } = this.state;
    return secondMenu.map(item => {
      return (
        <li key={item.id ? item.id : item.key}>
          {item.key ? <Link to={item.key} className={pageKey === item.key ? styles.active : ''}>{item.title}</Link> : <div onClick={this.setThirdMenuClick.bind(this, item.id, item.subcats)} className={`${secondNavId === item.id && thirdMenu.length > 0 ? styles.border_active : ''}`}>{item.title}</div>}
        </li>
      );
    })
  }
  setThirdMenuClick = (id, menu, e) => {
    this.setState({ secondNavId: id, thirdMenu: menu });
  }
  renderThirdMenu() {
    const productId = this.props.location.pathname.split("/")[2] || -1;
    const { thirdMenu } = this.state;
    return thirdMenu.map(item => {
      return (
        <li key={item.id}>
          <Link to={`/product/${item.id}`} className={parseInt(productId) === parseInt(item.id) ? styles.active : ''}>{item.title}</Link>
        </li>
      );
    })
  }

  renderNavIcon() {
    const { isShowNav } = this.state;
    return (
      <div className={styles.expand_nav_icon} onClick={this.handleExpandNav}>
        {isShowNav ? <img src="/images/close.png" alt="" /> : <img src="/images/expand_nav.png" alt="" />}
      </div>
    )
  }

  handleExpandNav = (e) => {
    e && e.nativeEvent.stopImmediatePropagation();
    const { isShowNav } = this.state;
    this.handleNavClick();
    if (!isShowNav) this.setState({ isShowNav: true, isShowInput: false });
    else {
      this.setState({isShowNav: false});
    }
  }
  handleSearchProduct = (e) => {
    e && e.nativeEvent.stopImmediatePropagation();
    const { isShowInput } = this.state;
    if (!isShowInput) this.setState({ isShowInput: true, isShowNav: false });
    else {
      this.SearchProductList();
    }
  }
  handleSearchChange = (e) => this.setState({ searchVal: e.target.value })

  //解决iOS字体小于16px自动缩放问题
  handleInputMouseDown = e => {
    e.target.style.fontSize = '16px';
  }
  handleInputFocus = e => {
    e.target.style.fontSize = '';
  }
  
  handleInputKeyUp = (e) => {
    if (e.keyCode === 13) {
      this.handleSearchProduct()
    }
  }
  SearchProductList = async () => {
    const { searchVal } = this.state;
    if (!searchVal) toast.error("搜索内容为空！");
    else {
      this.setState({ isLoading: true, showResult: true });
      const res = await axios.post(api.getProductList, { keyword: searchVal });
      this.setState({ list: res.data.data, count: res.data.count, isLoading: false, ambulance: res.ambulance });
    }
  }
  render() {
    const { menuList: headerMenuList } = this.props;
    const { isShowInput, isShowNav, secondMenu, thirdMenu, firstNavId, isLoading, showResult, list, ambulance, count } = this.state;
    return (
      <div className={styles.header_container}>
        <div className={styles.logo_container}>
          <Link to="/">
            <img src="/images/logo.png" alt="雅集logo" />
          </Link>
        </div>
        <div className={styles.menu_container}>
          <ul className={styles.menu_list}>
            {this.renderMenu(headerMenuList)}
            <li className={styles.searchIcon} onClick={this.handleSearchProduct}>
              <img src="/images/search.png" alt="" />
            </li>
          </ul>
          {/* 手机端导航 */}
          {this.renderNavIcon()}
          {/* 手机端搜索 */}
          <div className={styles.search_icon} onClick={this.handleSearchProduct}>
            <img src="/images/search.png" alt="" />
          </div>
          <div className={`${styles.phoneSearchInput} ${isShowInput ? styles.phoneShowSearchInput : ''}`} onClick={(e) => e.nativeEvent.stopImmediatePropagation()}>
            <input className={styles.input} placeholder="搜索产品" onChange={this.handleSearchChange} onKeyUp={this.handleInputKeyUp} />
          </div>
          <div className={`${styles.searchInput} ${isShowInput ? styles.showSearchInput : ''}`} onClick={(e) => e.nativeEvent.stopImmediatePropagation()}>
            <input 
              className={styles.input} 
              placeholder="搜索产品" 
              onChange={this.handleSearchChange} 
              onKeyUp={this.handleInputKeyUp} 
              onMouseDown={this.handleInputMouseDown}
              onFocus={this.handleInputFocus}
            />
          </div>
          {showResult ? (
            <div className={styles.result}>
              {isLoading ? <Loading /> : (
                count === 0 ? (
                  <div className={styles.noTips}>
                    <img src={NoProductIcon} alt="" style={{ width: 100 }} />
                    <div>暂无产品</div>
                  </div>
                ) : list.map(v => <SearchProduct key={v.id} {...v} ambulance={ambulance} />)
              )}
            </div>
          ) : null}
        </div>
        <div className={`${styles.nav_container} ${isShowNav ? styles.showNav : styles.hideNav}`}>
          <ul className={`${styles.first_menu} ${secondMenu.length > 0 ? styles.border_nav : ''}`}>
            <li onClick={this.setSecondMenuClick.bind(this, 0, headerMenuList)} className={`${firstNavId === 0 ? styles.border_active : ''}`}>产品分类</li>
            {this.renderFirstMenu(menuList)}
          </ul>
          <ul className={`${styles.second_menu} ${thirdMenu.length > 0 ? styles.border_nav : ''}`}>
            {this.renderSecondMenu()}
          </ul>
          <ul className={styles.third_menu}>
            {this.renderThirdMenu()}
          </ul>
        </div>
      </div>
    );
  }
}

export default Index;
